import React, { useEffect, useState } from "react";
import { Button, Typography, Box, TextField, Grid, MenuItem } from "@mui/material";
import { useForm } from "react-hook-form";
import { useNavigate, useParams, useSearchParams } from "react-router-dom"; // Hooks para navegação e busca de parâmetros
import sideImage from "../../images/robo.png";
import headerImage from "../../images/Logo-Pick-4.png";
import useResponsive from "../../services/useReponsive";
import { useDispatch } from "react-redux";


const SelecionarPlano = ({ }) => {
    const { register, handleSubmit, formState: { errors } } = useForm();
    const [corridasPorMes, setCorridasPorMes] = useState("");
    const navigate = useNavigate();
    const [searchParams] = useSearchParams(); // Hook para obter parâmetros da URL
    const isMobile = useResponsive();
    const { cupom } = useParams();

    const onSubmit = (data) => {
        if (corridasPorMes) {
            // Redireciona para a rota com o plano e o cupom
            navigate(`/assinar/plano${corridasPorMes}${cupom ? `/${cupom}` : ""}`);
        } else {
            alert("Por favor, selecione a quantidade de corridas.");
        }
    };

    return (


        <Box
            sx={{
                width: "100%",
                height: "100vh",
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                justifyContent: "center",
                alignItems: "center",
                overflow: "hidden",
            }}
        >

            {/* Header */}
            {isMobile && <Box
                sx={{
                    width: "100%", // Largura total no mobile
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: isMobile ? "1rem 0" : "0", // Espaçamento no mobile
                }}
            >
                <img
                    src={headerImage}
                    alt="Header"
                    style={{
                        height: "10vh",
                    }}
                />
            </Box>}
            {/* Conteúdo */}
            <Box
                sx={{
                    width: isMobile ? "100%" : "50%", // Ajusta a largura no desktop
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: isMobile ? "1rem" : "2rem",
                    boxSizing: "border-box",
                    backgroundColor: "white",
                    borderRight: isMobile ? "none" : "1px solid #e0e0e0", // Borda no desktop
                }}
            >
                {!isMobile && <Box
                    sx={{
                        width: "100%", // Largura total no mobile
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: isMobile ? "1rem 0" : "0", // Espaçamento no mobile
                    }}
                >
                    <img
                        src={headerImage}
                        alt="Header"
                        style={{
                            height: "10vh",
                        }}
                    />
                </Box>}
                <Grid
                    width={isMobile ? "90%" : "70%"}
                    maxWidth="100%"
                    justifyContent="center"
                    textAlign="center"
                    sx={{
                        boxSizing: "border-box",
                    }}
                >
                    <Typography variant={"h6"} alignSelf={"center"} mb={2}>
                        Selecione quantas corridas você realiza por mês:
                    </Typography>
                    <form onSubmit={handleSubmit(onSubmit)} style={{ width: "100%" }}>
                        <TextField
                            select
                            size="small"
                            label="Corridas por mês"
                            value={corridasPorMes}
                            onChange={(e) => setCorridasPorMes(e.target.value)}
                            sx={{
                                width: "100%",
                                mb: 2,
                                textAlign: "left",
                                "& .MuiSelect-select": {
                                    textAlign: "left",
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#ff9f0d",
                                },
                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#ff9f0d",
                                },
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#ff9f0d",
                                },
                                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#ff9f0d",
                                },
                                "& .MuiInputLabel-root.Mui-focused": {
                                    color: "#ff9f0d",
                                },
                                "& .MuiSelect-icon": {
                                    color: "#ff9f0d",
                                },
                                "& .MuiSelect-root:focus": {
                                    borderColor: "#ff9f0d",
                                },
                            }}
                        >
                            <MenuItem value="">Selecione...</MenuItem>
                            <MenuItem value={500}>Até 500 corridas</MenuItem>
                            <MenuItem value={1000}>Até 1000 corridas</MenuItem>
                            <MenuItem value={1500}>Até 1500 corridas</MenuItem>
                            <MenuItem value={2000}>Até 2000 corridas</MenuItem>
                            <MenuItem value={3000}>Até 3000 corridas</MenuItem>
                            <MenuItem value={4000}>Até 4000 corridas</MenuItem>
                            <MenuItem value={5000}>Até 5000 corridas</MenuItem>
                            <MenuItem value={8000}>Até 8000 corridas</MenuItem>
                            <MenuItem value={10000}>Até 10000 corridas</MenuItem>
                        </TextField>
                        <Box
                            sx={{
                                pt: "0",
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            <Button
                                type="submit"
                                variant="contained"
                                sx={{
                                    backgroundColor: "orange",
                                    "&:hover": {
                                        backgroundColor: "orange",
                                    },
                                    borderRadius: "8px",
                                    color: "white",
                                    fontWeight: "400",
                                    fontFamily: "sans-serif",
                                }}
                            >
                                Continuar
                            </Button>
                        </Box>
                    </form>
                </Grid>
            </Box>

            {/* Side Image */}
            <Box
                sx={{
                    width: isMobile ? "100%" : "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: isMobile ? "1rem 0" : "0",
                }}
            >
                <img
                    src={sideImage}
                    alt="Side"
                    style={{
                        height: isMobile ? "40vh" : "80vh",
                        maxWidth: "100%", // Garante que não ultrapasse o contêiner
                    }}
                />
            </Box>
        </Box>



    );
};

export default SelecionarPlano;
